<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Loader from "@/components/widgets/loader";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
import forminput from "../formcomponet/forminput.vue";
import formtextarea from "../formcomponet/formtextarea.vue";
import formcheckbox from "../formcomponet/formcheckbox.vue";
import formdate from "../formcomponet/formdate.vue";
import configs from "@/models/configs"; 
import configtranslations from "../configtranslations/addedit.vue";
export default {
  mixins: [apibtoast, apigeneric, configs],
  page: {
    title: "Site Ayarları",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Layout,
    PageHeader,
    configtranslations,
    forminput,
    formtextarea,
    formcheckbox,
    formdate
  },
  data() {
    return {
      title: this.$t("configs.Title"),
      items: [
        {
          text: this.$t("configs.Page.Anasayfa"),
          href: "/",
        },
        {
          text: this.$t("configs.Page.UstMenu"),
          active: true,
        },
        {
          text: this.$t("configs.Title"),
          active: true,
        },
      ],
      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },
      FormData: {},
      DataUpdate: "",
      languages: {},
      website:{}
    };
  },
  methods: {
    Get() {
      this.ActionsFilterGet({
        Service: "configs",
        Page: this.Page,
        Filter: "&Websiteid="+window.$cookies.get("website"),
      }).then((res) => {
        this.FormData = res.Data[0];
        
          this.ActionsSingleGet({ Service: "website", Id: res.Data[0].Websiteid }).then((res) => {
        this.website = res; 
      });
        
      }); 
      
      let Page= {
        PageNumber: "1",
        PageSize: "99999",
        PageDataSize: "1",
      }
        this.ActionsGet({ Service: "languages", Page: Page }).then((res) => {
        this.languages = res.Data; 
      });


    },
    onSubmit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.Update("configs", this.FormData).then();
      }
    },
    
    FileUpload(FieldName) { 
      var file = this.$refs.[FieldName].files[0]; 
      let x = file.name;
      //this.FormData.Filename = this.file.name;
      let uzanti = x.substr(
        x.lastIndexOf(".") + 1,
        x.length - x.lastIndexOf(".")
      ); 
       if ( uzanti=='png' || uzanti=='jpeg' || uzanti=='jpg'  || uzanti=='p12' ) { 
                  let formData = new FormData();
                  formData.append("file", file);
                  this.ActionsPost({
                    Service: "GenericFileUpDownload/UploadFile?pathUrl=Web",
                    Data: formData,
                  }).then((res) => { 
                    if (res.Succeeded == true) { 
                      this.FormData.[FieldName] =  res.Data.filename; 
                      this.$toast.success(this.$t("ToasMessage.FilePozitif"));
                    } else {
                      this.$toast.error(this.$t("ToasMessage.FileNegatif"));
                    }
                  });

      }else{
        this.$toast.error(this.$t("ToasMessage.FileNegatifUzanti"));
      }
  },}
};
</script>

<template>
  <Loader>
    <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">  
        <div class="col-xl-12">
          <b-tabs content-class="p-3 text-muted">
            <b-tab active class="border-0">
              <template v-slot:title>
                <span class="d-inline-block d-sm-none">
                  <i class="fas fa-home"></i>
                </span>
                <span class="d-none d-sm-inline-block">
    <country-flag country='tr' size='small'/>Türkçe</span>
              </template>

              <Form @submit.prevent="onSubmit">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title mb-4">
                      {{ $t("configs.AddEdit.SeoAyarlari.Title") }}
                    </h4>
                    <div class="row mb-2">
                      <div class="col-sm-12">
                        <forminput
                          :FormDataType="FormDataType.Sitebaslik"
                          :Value="FormData.Sitebaslik"
                          :v="$v.FormData.Sitebaslik"
                          @input="FormData.Sitebaslik = $event"
                        />
                        <forminput
                          :FormDataType="FormDataType.Siteanahtarkelimeler"
                          :Value="FormData.Siteanahtarkelimeler"
                          :v="$v.FormData.Siteanahtarkelimeler"
                          @input="FormData.Siteanahtarkelimeler = $event"
                        />
                        <formtextarea
                          :FormDataType="FormDataType.Siteaciklama"
                          :Value="FormData.Siteaciklama"
                          :v="$v.FormData.Siteaciklama"
                          @input="FormData.Siteaciklama = $event"
                        />
                        <formtextarea
                          :FormDataType="
                            FormDataType.Googleanalyticsentegrasyonkodu
                          "
                          :Value="FormData.Googleanalyticsentegrasyonkodu"
                          :v="$v.FormData.Googleanalyticsentegrasyonkodu"
                          @input="
                            FormData.Googleanalyticsentegrasyonkodu = $event
                          "
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title mb-4">
                      {{
                        $t("configs.AddEdit.GoogleAnalyticsEntegrasyonu.Title")
                      }}
                    </h4>
                    <div class="row mb-2">
                      <div class="col-sm-12">
                        <b-form-group
                          id="example text"
                          :label="
                            FormDataType.Googleanalyticskeyfilepath.FieldTitle
                          "
                          label-for="text"
                          class="mb-3"
                        >
                          <span>{{ FormData.Googleanalyticskeyfilepath }}</span>
                          <input
                            class="form-control"
                            ref="Googleanalyticskeyfilepath"
                            type="file"
                            v-on:change="
                              FileUpload('Googleanalyticskeyfilepath')
                            "
                            id="FormData.Googleanalyticskeyfilepath"
                            accept=".p12"
                          />
                        </b-form-group>
                        <forminput
                          :FormDataType="
                            FormDataType.Googleanalyticsserviceaccountemail
                          "
                          :Value="FormData.Googleanalyticsserviceaccountemail"
                          :v="$v.FormData.Googleanalyticsserviceaccountemail"
                          @input="
                            FormData.Googleanalyticsserviceaccountemail = $event
                          "
                        />
                        <forminput
                          :FormDataType="
                            FormDataType.Googleanalyticskeypassword
                          "
                          :Value="FormData.Googleanalyticskeypassword"
                          :v="$v.FormData.Googleanalyticskeypassword"
                          @input="FormData.Googleanalyticskeypassword = $event"
                        />
                        <forminput
                          :FormDataType="
                            FormDataType.Googleanalyticswebsitecode
                          "
                          :Value="FormData.Googleanalyticswebsitecode"
                          :v="$v.FormData.Googleanalyticswebsitecode"
                          @input="FormData.Googleanalyticswebsitecode = $event"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title mb-4">
                      {{ $t("configs.AddEdit.IletisimBilgileri.Title") }}
                    </h4>
                    <div class="row mb-2">
                      <div class="col-sm-12">
                        <formtextarea
                          :FormDataType="FormDataType.Contactaddress"
                          :Value="FormData.Contactaddress"
                          :v="$v.FormData.Contactaddress"
                          @input="FormData.Contactaddress = $event"
                        />
                        <forminput
                          :FormDataType="FormDataType.Contactphone"
                          :Value="FormData.Contactphone"
                          :v="$v.FormData.Contactphone"
                          @input="FormData.Contactphone = $event"
                        />
                        <forminput
                          :FormDataType="FormDataType.Contactfax"
                          :Value="FormData.Contactfax"
                          :v="$v.FormData.Contactfax"
                          @input="FormData.Contactfax = $event"
                        />
                        <forminput
                          :FormDataType="FormDataType.Contactemail"
                          :Value="FormData.Contactemail"
                          :v="$v.FormData.Contactemail"
                          @input="FormData.Contactemail = $event"
                        />
                        <formtextarea
                          :FormDataType="FormDataType.Contactmap"
                          :Value="FormData.Contactmap"
                          :v="$v.FormData.Contactmap"
                          @input="FormData.Contactmap = $event"
                        />
                        <formcheckbox
                          :FormDataType="FormDataType.Contactbildirimvarmi"
                          :Value="FormData.Contactbildirimvarmi"
                          :v="$v.FormData.Contactbildirimvarmi"
                          @input="FormData.Contactbildirimvarmi = $event"
                        />
                        <formtextarea
                          :FormDataType="
                            FormDataType.Gonderimyapilacakepostalar
                          "
                          :Value="FormData.Gonderimyapilacakepostalar"
                          :v="$v.FormData.Gonderimyapilacakepostalar"
                          @input="FormData.Gonderimyapilacakepostalar = $event"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card" v-if=" 1 == 2">
                  <div class="card-body">
                    <h4 class="card-title mb-4">
                      {{ $t("configs.AddEdit.SMTPBilgileri.Title") }}
                    </h4>
                    <div class="row mb-2">
                      <div class="col-sm-12">
                        <forminput
                          :FormDataType="FormDataType.Epostagonderenadi"
                          :Value="FormData.Epostagonderenadi"
                          :v="$v.FormData.Epostagonderenadi"
                          @input="FormData.Epostagonderenadi = $event"
                        />
                        <forminput
                          :FormDataType="FormDataType.Epostamailserver"
                          :Value="FormData.Epostamailserver"
                          :v="$v.FormData.Epostamailserver"
                          @input="FormData.Epostamailserver = $event"
                        />
                        <forminput
                          :FormDataType="FormDataType.Epostamailserverport"
                          :Value="FormData.Epostamailserverport"
                          :v="$v.FormData.Epostamailserverport"
                          @input="FormData.Epostamailserverport = $event"
                        />
                        <formcheckbox
                          :FormDataType="FormDataType.Epostasslaktif"
                          :Value="FormData.Epostasslaktif"
                          :v="$v.FormData.Epostasslaktif"
                          @input="FormData.Epostasslaktif = $event"
                        />
                        <forminput
                          :FormDataType="FormDataType.Epostakullaniciadi"
                          :Value="FormData.Epostakullaniciadi"
                          :v="$v.FormData.Epostakullaniciadi"
                          @input="FormData.Epostakullaniciadi = $event"
                        />
                        <forminput
                          :FormDataType="FormDataType.Epostasifre"
                          :Value="FormData.Epostasifre"
                          :v="$v.FormData.Epostasifre"
                          @input="FormData.Epostasifre = $event"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title mb-4">
                      {{ $t("configs.AddEdit.SosyalMedya.Title") }}
                    </h4>
                    <div class="row mb-2">
                      <div class="col-sm-12">
                        <forminput
                          :FormDataType="FormDataType.Facebook"
                          :Value="FormData.Facebook"
                          :v="$v.FormData.Facebook"
                          @input="FormData.Facebook = $event"
                        />
                        <forminput
                          :FormDataType="FormDataType.Twitter"
                          :Value="FormData.Twitter"
                          :v="$v.FormData.Twitter"
                          @input="FormData.Twitter = $event"
                        />
                        <forminput
                          :FormDataType="FormDataType.Googleplus"
                          :Value="FormData.Googleplus"
                          :v="$v.FormData.Googleplus"
                          @input="FormData.Googleplus = $event"
                        />
                        <forminput
                          :FormDataType="FormDataType.Pinterest"
                          :Value="FormData.Pinterest"
                          :v="$v.FormData.Pinterest"
                          @input="FormData.Pinterest = $event"
                        />
                        <forminput
                          :FormDataType="FormDataType.Linkedin"
                          :Value="FormData.Linkedin"
                          :v="$v.FormData.Linkedin"
                          @input="FormData.Linkedin = $event"
                        />
                        <forminput
                          :FormDataType="FormDataType.Instegram"
                          :Value="FormData.Instegram"
                          :v="$v.FormData.Instegram"
                          @input="FormData.Instegram = $event"
                        />
                        <forminput
                          :FormDataType="FormDataType.Youtube"
                          :Value="FormData.Youtube"
                          :v="$v.FormData.Youtube"
                          @input="FormData.Youtube = $event"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title mb-4">
                      {{ $t("configs.AddEdit.Gorseller.Title") }}
                    </h4>
                    <div class="row mb-2">
                      <div class="col-sm-12">
                        <b-form-group
                          id="example text"
                          :label="FormDataType.Sitelogo.FieldTitle"
                          label-for="text"
                          class="mb-3"
                        >
                          <span>{{ FormData.Sitelogo }}</span>
                          <input
                            class="form-control"
                            ref="Sitelogo"
                            type="file"
                            v-on:change="FileUpload('Sitelogo')"
                            id="FormData.Sitelogo"
                            accept=".jpg, .jpeg, .png "
                          />
                        </b-form-group>
                        <b-form-group
                          id="example text"
                          :label="FormDataType.Favicon.FieldTitle"
                          label-for="text"
                          class="mb-3"
                        >
                          <span>{{ FormData.Favicon }}</span>
                          <input
                            class="form-control"
                            ref="Favicon"
                            type="file"
                            v-on:change="FileUpload('Favicon')"
                            id="FormData.Favicon"
                            accept=".jpg, .jpeg, .png "
                          />
                        </b-form-group>
                        <formtextarea
                          :FormDataType="FormDataType.Introductionvideo"
                          :Value="FormData.Introductionvideo"
                          :v="$v.FormData.Introductionvideo"
                          @input="FormData.Introductionvideo = $event"
                        /> 
                      </div>
                    </div>
                  </div>
                </div> 
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title mb-4">
                      {{ $t("configs.AddEdit.MezunConfig.Title") }}
                    </h4>
                    <div class="row mb-2">
                      <div class="col-sm-12">
                        <formcheckbox
                          :FormDataType="FormDataType.Mezungelismisfiltreleme"
                          :Value="FormData.Mezungelismisfiltreleme"
                          :v="$v.FormData.Mezungelismisfiltreleme"
                          @input="FormData.Mezungelismisfiltreleme = $event"
                        />  <formcheckbox
                          :FormDataType="FormDataType.Mezunharitagelismisfiltreleme"
                          :Value="FormData.Mezunharitagelismisfiltreleme"
                          :v="$v.FormData.Mezunharitagelismisfiltreleme"
                          @input="FormData.Mezunharitagelismisfiltreleme = $event"
                        />
                        <formcheckbox
                          :FormDataType="FormDataType.Isilanlarigelismisfiltreleme"
                          :Value="FormData.Isilanlarigelismisfiltreleme"
                          :v="$v.FormData.Isilanlarigelismisfiltreleme"
                          @input="FormData.Isilanlarigelismisfiltreleme = $event"
                        />
                          <formcheckbox
                          :FormDataType="FormDataType.Mezunharitatablogozuksun"
                          :Value="FormData.Mezunharitatablogozuksun"
                          :v="$v.FormData.Mezunharitatablogozuksun"
                          @input="FormData.Mezunharitatablogozuksun = $event"
                        />  
                        <formcheckbox
                          :FormDataType="FormDataType.Mezunlarbirbirinigorsun"
                          :Value="FormData.Mezunlarbirbirinigorsun"
                          :v="$v.FormData.Mezunlarbirbirinigorsun"
                          @input="FormData.Mezunlarbirbirinigorsun = $event"
                        />  
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title mb-4">
                      {{ $t("configs.AddEdit.Kvkk.Title") }}
                    </h4>
                    <div class="row mb-2">
                      <div class="col-sm-12">
                        <formcheckbox
                          :FormDataType="FormDataType.Kvkk"
                          :Value="FormData.Kvkk"
                          :v="$v.FormData.Kvkk"
                          @input="FormData.Kvkk = $event"
                        /> <formdate
                          :FormDataType="FormDataType.Kvkktarihi"
                          :Value="FormData.Kvkktarihi"
                          :v="$v.FormData.Kvkktarihi"
                          @input="FormData.Kvkktarihi = $event"
                        />
                        
                        <formtextarea
                          :FormDataType="FormDataType.Kvkkmetni"
                          :Value="FormData.Kvkkmetni"
                          :v="$v.FormData.Kvkkmetni"
                          @input="FormData.Kvkkmetni = $event"
                        />
                          
                        <button class="btn btn-primary" type="submit">
                          {{ $t("dpagecategories.AddEdit.Button") }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </Form>
            </b-tab>
            <template v-for="(Data, index) in languages">
              <b-tab :key="index" v-if="Data.Shorttitle != 'tr'">
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="far fa-user"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">
    <country-flag :country='Data.Flag' size='small'/>{{ Data.Title }}</span>
                </template>
                <configtranslations :DataId="FormData.Id" :LanId="Data.Id" />
              </b-tab>
            </template>
          </b-tabs>
        </div>
      </div>
    </Layout>
  </Loader>
</template>
